export enum Permission {
  RetailerContactManagementView = 'retailer_contact_management.view',
  RetailerContactManagementModify = 'retailer_contact_management.modify',
}
